import api from '../../../services/segi/index'

const segiHeaders = {
  'Content-Type': 'multipart/form-data',
  Accept: 'multipart/form-data',
}

/** Retorno de getBancoHorasAcumulado — inclui acumulado por mês em [MM/YYYY].banco_aumulado */
export async function fetchBancoAcumulado(graphId) {
  const formData = new FormData()
  formData.append('id', graphId)
  formData.append('acao', 'banco_acumulado')
  const res = await api.post('/', formData, { headers: segiHeaders })
  return res.data
}
